/**
 * Fusus deployment region codes.
 *
 * This enum mirrors the backend's FususRegionCode from:
 * fieldwatch-api/src/common/constants.py:FususRegionCode
 *
 * Note: The backend uses this as a TextChoices enum but exposes region
 * as a plain string via settings.FUSUS_REGION_CODE. Keep this enum in sync
 * with backend changes to region codes.
 *
 * @see https://git.taservs.net/rto/fieldwatch-api/blob/dev/src/common/constants.py
 */
export enum FususRegionCode {
  Dev = 'dev',
  Dev1 = 'dev1',
  QA = 'qa',
  Stg = 'stg',
  US1 = 'us1',
  US4 = 'us4', // Enterprise region
  US3 = 'us3',
  CA = 'ca',
  AU = 'au',
  UK = 'uk',
  EU = 'eu',
}
